(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["celion-system"] && !Shopify.designMode) return;
  try {
    if (!window.celionFormsReady) {
    window.celionFormsReady = true;
    const ceMoney = (value, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:currency || 'EGP'}).format(value / 100);
    document.addEventListener('change', event => {
      if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-ce-variant]')) return;
      const form=event.target.closest('.ce-add-form');
      const selections=[...form.querySelectorAll('[data-ce-variant]')];
      if (selections.some(select => !select.value)) return;
      const price=selections.reduce((total,select)=>total+Number(select.selectedOptions[0].dataset.price || 0),0);
      const totals=(form.closest('.ce-look-options') || form).querySelectorAll('[data-ce-total]');
      totals.forEach(output => output.textContent=ceMoney(price,form.dataset.currency));
    });
    document.addEventListener('submit', async event => {
      const form=event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('.ce-add-form')) return;
      event.preventDefault();
      if(form.dataset.busy==='true' || !form.reportValidity()) return;
      const button=form.querySelector('[type="submit"]');
      const status=form.querySelector('.ce-form-status');
      const language=document.getElementById('ce-language').dataset;
      const initial=button.textContent;
      const items=[...form.querySelectorAll('[data-ce-variant]')].map(select=>({id:Number(select.value),quantity:1}));
      if(items.some(item=>!item.id)) return;
      form.dataset.busy='true';form.setAttribute('aria-busy','true');button.disabled=true;button.textContent=language.adding;status.textContent='';
      let added=false;
      try {
        const root=window.Shopify?.routes?.root || '/';
        const sections=[...new Set([...document.querySelectorAll('cart-items-component')].map(el=>el.dataset.sectionId).filter(Boolean))].slice(0,5);
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections,sections_url:window.location.pathname})});
        const result=await response.json();
        if(!response.ok || result.status) throw new Error(typeof result.description==='string'?result.description:language.error);
        added=true;
        const cartResponse=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});
        if(!cartResponse.ok) { window.location.assign(root+'cart'); return; }
        const cart=await cartResponse.json();
        status.textContent=language.added;
        document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'celion-form',data:{source:'celion-form',itemCount:items.length,sections:result.sections || {}}}}));
        if(!document.querySelector('cart-drawer-component')) window.location.assign(root+'cart');
      } catch(error) {
        if(added) { window.location.assign((window.Shopify?.routes?.root || '/')+'cart'); return; }
        status.textContent=error.message || language.error;
      } finally { form.dataset.busy='false';form.removeAttribute('aria-busy');button.disabled=false;button.textContent=initial; }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
